import { Heading, Text, VStack } from '@bpba/ui-components';
import { Establecimiento } from '../../rest/models/Establecimiento';
import { ReactNode } from 'react';
import { TIPO_PACTAR } from '../../Constantes';
import InformacionAdicional from './InformacionAdicional';

export const GrillaMobile = ({ establecimientos, tipo }: { establecimientos: Establecimiento[]; tipo: string }) => {
  const Tarjeta = ({ title, children }: { title?: string; children: ReactNode }) => {
    return (
      <VStack border="1px solid" borderColor="secondary.1" bg="white" m="10px 0" p="10px" borderRadius="6px 24px 6px 24px">
        {title && <Heading level={4}>{title}</Heading>}
        {children}
      </VStack>
    );
  };

  const Row = ({ children }: { children: ReactNode }) => (
    <Text my="2px" color="primary.1">
      {children}
    </Text>
  );

  return (
    <>
      {establecimientos.length === 0 && (
        <Tarjeta>
          <Row>No se encontraron comercios</Row>
        </Tarjeta>
      )}
      {establecimientos?.map((value, index) => {
        if (tipo === TIPO_PACTAR) {
          return (
            <Tarjeta key={index} title={value.denominacion}>
              <Row>
                {value.localidad} <br></br>
              </Row>
              <Row>
                <b>{value.rubro}</b><br></br>
              </Row>
              <Row>
                <b>{value.region?value.region:'-'}</b>
              </Row>
              {!!value.denominacion.length && (
                <Heading level={4} mb={1}>
                  Información adicional
                </Heading>
              )}
              {!!value.denominacion.length && <InformacionAdicional showTitle={false} informacionAdicional={value} />}
            </Tarjeta>
          );
        } else  {
          return (
            <Tarjeta key={index} title={value.denominacion}>
              <Row>
                {value.localidad} <br></br>
              </Row>
              <Row>
                <b>{value.rubro}</b>
              </Row>
              
            </Tarjeta>
          );
        }
      })}
    </>
  );
};
